import { useAssignUsersToGroupMutation } from '../../../../../graphql'
import { useShowSuccess, useShowError } from 'hooks/useToast'

export default function useAddUsersHandler() {
	const [ addUsersToGroup ] = useAssignUsersToGroupMutation()
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( group: { id: number }, users: { user_id: number }[] ) => {
		const groupId = group.id
		const userIds = users.map( ( user ) => user.user_id )

		const result = await addUsersToGroup( { variables: { groupId, userIds } } )
		if ( result.data?.assignUsersToGroup?.success ) {
			showSuccess( `assignUsersToGroupSuccess${Date.now()}`, result.data?.assignUsersToGroup?.message ?? 'Successfully added users to group!' )
		} else {
			showError( `assignUsersToGroupError${Date.now()}`, result.data?.assignUsersToGroup?.message ?? 'Sorry, an error occurred' )
		}
	}
}
